import 'slick-carousel'

export default (() => {

  // Make all images the same height as the shortest image
  var shortestHeight = false;
  var imgCountLoaded = 0;

  initImageHeights(false);

  // Resize slide heights on window resize
  $(window).resize(function() {
    waitForFinalEvent(function() {
      resizeImageHeights();
    }, 250, 'windowResizeForCarousel');
  });

  function initImageHeights() {
    var $images = $('.js-image-carousel .image-carousel-slide img');

    $images.one('load', function() { // A slide image has loaded
      imgCountLoaded++;
      if(imgCountLoaded == $images.length) { // Only fire resize logic when last image is loaded
        imageHeights($images, false);
      }
    }).each(function() { // Manual fire "load" event if image is coming from cache
      if(this.complete) {
          $(this).trigger('load');
      }
    });
  }

  function resizeImageHeights() {
    var $images = $('.js-image-carousel .image-carousel-slide img');

    shortestHeight = false;
    $images.removeAttr('style');
    imageHeights($images, true);
  }

  function imageHeights($images, reinit) {
      $images.each(function() { // Loop each image, check if height is shortest
        if(!shortestHeight || $(this).height() < shortestHeight) {
          shortestHeight = $(this).height();
        }
      });
      if(shortestHeight) {
        $images.css({'height': shortestHeight, 'width': 'auto'}); // Reset heights of all images to shortest
      }
      initCarousel(reinit);
  }

  // Init slick
  function initCarousel(reinit) {
    $('.js-image-carousel').each(function() {
      var imageSlider = $(this);

      if(reinit) {
        imageSlider.slick('destroy');
      }

      // Slick on init event
      imageSlider.on('init beforeChange', function(event, slick) {

        // Handle figcaptions show more links
        imageSlider.find('.slick-slide figcaption').each(function() {

          var $showMoreButton = $('<a class="link show-more">Show more</a>');
          var $figText = $(this).find('.fig-caption-text');

          $(this).find('.show-more').remove();
          $figText.removeAttr('style').removeClass('expandable truncate smooth');

          // Show more link click events
          $showMoreButton.one("click", showMore);
          function showMore() {
            $figText.removeClass('truncate');
            $showMoreButton.text('Show less');
            $showMoreButton.one("click", showLess);
          }
          function showLess() {
            $figText.addClass('truncate');
            $showMoreButton.text('Show more');
            $showMoreButton.one("click", showMore);
          }

          // If figcaption height > 66, apply show more classes
          if($figText.height() > 66) {
            $figText.css({'max-height': $figText.height()}).addClass('expandable truncate');
            $(this).append($showMoreButton);

            setTimeout(function() {
              $figText.addClass('smooth'); // Do this last to prevent max-height jumping around
            }, 250);
          }
        });
      });

      imageSlider.slick({
        adaptiveHeight: true,
        dots: true,
        prevArrow: $(this).parent().find('.image-slider-previous'),
        nextArrow: $(this).parent().find('.image-slider-next')
      });

    });
  }

  var waitForFinalEvent = (function () {
    var timers = {};
    return function (callback, ms, uniqueId) {
      if (!uniqueId) {
        uniqueId = "Don't call this twice without a uniqueId";
      }
      if (timers[uniqueId]) {
        clearTimeout (timers[uniqueId]);
      }
      timers[uniqueId] = setTimeout(callback, ms);
    };
  })();


})()
